import Big from 'big.js';
import { EMembership } from '@enums/EMembership';
import { IMembershipTresholds } from '@appInterfaces/IBFAppSettings';

export enum EMembershipStatusRender {
  list = 'list',
  inline = 'inline',
}

export default interface IMembershipStatus {
  amount: Big;
  currentStatus: EMembership;
  membershipTresholds: IMembershipTresholds;
  onMembershipSelect: (amount: string) => void;
  renderType: EMembershipStatusRender;
  walletBalance: Big;
}
